import React, { Component } from "react";
import { showLoader, removeLoader } from "deskera-ui-library";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import CampaignManager from "./CampaignManager";
import TemplateManager from "./templates/TemplateManager";
import PageDesigner from "../page_designer/PageDesigner";
import { PAGE_TYPE } from "../page_designer/ComponentList";
import SavePopup from "../common/SavePopup";
import { CampaignService } from "../../services/campaign";
import Utility from "../../utility/Utility";
import { COLUMN_CODE } from "../../managers/TableManger";
import CampaignPageHeader from "./CampaignPageHeader";
import ComponentManager from "../page_designer/ComponentManager";
import HtmlGenerator from "../page_designer/HtmlGenerator";

export default class CampaignBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSegment: 0,
      isEdit: CampaignManager.isPageDataAvailable() ? true : false,
      jsonData: CampaignManager.isPageDataAvailable()
        ? this.getTemplate()
        : TemplateManager.getTemplate(),
      needSaveButton: true,
      campaignData: [],
      campaignName: "New Campaign",
      dataReceived: false,
    };

    this.pageDataToSave = null;
    this.pageType = PAGE_TYPE.CAMPAIGN;
  }

  componentDidMount() {
    RouteManager.setPresenter(this);
    if (!CampaignManager.isPageDataAvailable() && this.props.match.params.id) {
      this.setState({ jsonData: [] });
      CampaignManager.fetchPageDataById(this.props.match.params.id, () => {
        this.setState(
          { jsonData: this.getTemplate(), dataReceived: true, isEdit: true },
          () => this.onEditData()
        );
      });
    } else {
      this.setState({ dataReceived: true });
    }
  }

  render() {
    return (
      <div className="parent-width align-items-start parent-height">
        <div className="row justify-content-between">
          <CampaignPageHeader
            title={"Template Designer"}
            stepperIndex={1}
            onSave={this.saveTapped}
          />
        </div>

        {this.state.dataReceived && (
          <PageDesigner
            readOnly={CampaignManager.checkCampaignSent()}
            type={PAGE_TYPE.CAMPAIGN}
            components={
              Array.isArray(this.state.jsonData)
                ? this.state.jsonData
                : this.state.jsonData.designElements
            }
            scripts={this.state.jsonData.scripts}
            metaData={this.state.jsonData.metaData}
            hash={this.state.jsonData.hash}
            onDataChange={(data) => {
              this.pageDataToSave = data;
            }}
            onSave={() => {
              this.saveTapped();
            }}
          />
        )}
        {this.state.needSavePopup && this.getSavePopup()}
      </div>
    );
  }

  saveTapped = () => {
    //////////////////////////////////////////////////////////////////
    // THIS IS TO SEND EMAIL from NEXT Step
    const htmlGenerator = new HtmlGenerator();
    let data = this.pageDataToSave;
    const htmlData = htmlGenerator.getHTML(
      data.json.designElements,
      data.json.scripts,
      data.json.metaData,
      data.json.hash,
      this.pageType
    );
    CampaignManager.setTemplateHTMLData(htmlData);
    // THIS IS TO SEND EMAIL from NEXT Step
    //////////////////////////////////////////////////////////////////
    this.setState(
      {
        campaignJson: this.pageDataToSave.json,
        campaignHtml: this.pageDataToSave.html,
        campaignHash: this.pageDataToSave.hash,
      },
      () => {
        if (this.state.isEdit) {
          this.onUpdate(this.state.campaignName);
        } else {
          this.showSavePopup();
        }
      }
    );
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  getSavePopup() {
    return (
      <SavePopup
        title={this.state.campaignName}
        header="Campaign Name"
        headerIcon="🎯"
        subHeader="Enter a name to help you remember what this campaign is all about. Only you will see this."
        onCancel={this.onPopupCancel}
        onSave={this.onPopupSave}
      />
    );
  }

  //////////////////////////////////////////////////////

  showSavePopup = () => {
    this.setState({
      needSavePopup: true,
    });
  };
  hideSavePopup = () => {
    this.setState({
      needSavePopup: false,
    });
  };

  //////////////////////////////////////////////////////
  requestData = (title) => {
    const encodedDataToSave = ComponentManager.getEncodedDataToSave(
      this.pageDataToSave,
      this.pageType
    );
    let rowData = {};
    rowData.name = title;
    rowData.html = encodedDataToSave.html;
    rowData.json = encodedDataToSave.json;
    rowData.hash = encodedDataToSave.hash;
    return rowData;
  };

  onPopupSave = (title, domain) => {
    this.hideSavePopup();
    const tableId = CampaignManager.getTableId();
    const requestData = CampaignManager.getRequestToSavePage(
      this.requestData(title)
    );
    if (requestData !== {}) {
      showLoader("Save template...");
      CampaignService.add(requestData, tableId)
        .then((data) => {
          CampaignManager.setPageData(data);
          const pageId = CampaignManager.getCampaignId()
            ? "/" + CampaignManager.getCampaignId()
            : "";
          RouteManager.navigateToPage(PAGE_ROUTES.CAMPAIGN_SUMMARY + pageId);
          removeLoader();
        })
        .catch((err) => {
          console.log(err);
          removeLoader();
        });
    }
  };

  onUpdate = (title) => {
    this.hideSavePopup();
    const tableId = CampaignManager.getTableId();
    const requestData = CampaignManager.getRequestToUpdatePage(
      this.requestData(title)
    );
    if (requestData !== {}) {
      const campaignId = CampaignManager.getCampaignId();
      if (this.state.isEdit && !Utility.isEmpty(campaignId)) {
        showLoader("Updating template...");
        CampaignService.update(requestData, tableId, campaignId)
          .then((data) => {
            const pageId = CampaignManager.getCampaignId()
              ? "/" + CampaignManager.getCampaignId()
              : "";
            CampaignManager.setPageData(data);
            RouteManager.navigateToPage(PAGE_ROUTES.CAMPAIGN_SUMMARY + pageId);
            removeLoader();
          })
          .catch((err) => {
            console.log(err);
            removeLoader();
          });
      }
    }
  };

  onPopupCancel = () => {
    this.hideSavePopup();
  };

  setCampaignData = (name, value) => {
    let campaign = this.state.campaignData;
    if (campaign === null) {
      return;
    }
    campaign.forEach((data, index) => {
      if (data.name === name) {
        campaign[index].value = value;
      }
    });
    this.setState({ campaignData: campaign });
  };

  onEditData = () => {
    if (!this.state.isEdit) {
      return;
    }
    const campaignData = CampaignManager.getPageData();
    let campaignNameId = CampaignManager.getColumnId(COLUMN_CODE.CAMPAIGN.NAME);
    let campaignJsonId = CampaignManager.getColumnId(
      COLUMN_CODE.CAMPAIGN.JSON_DATA
    );
    this.setState({
      campaignName: campaignData.data.cells[campaignNameId],
      campaignJson: Utility.decodeJSON(campaignData.data.cells[campaignJsonId]),
    });
  };

  getTemplate = () => {
    const campaignData = CampaignManager.getPageData();
    let campaignJsonId = CampaignManager.getColumnId(
      COLUMN_CODE.CAMPAIGN.JSON_DATA
    );
    return Utility.decodeJSON(campaignData.data.cells[campaignJsonId]);
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////////////////////
}
